import React, { ReactElement, ReactNode } from 'react'

import { Alignment } from '../../../../types/alignment'
import { Size } from '../../types/size'
import * as Styled from './styles'

interface ModalFooterProps {
  alignment?: Alignment
  children?: ReactNode
  className?: string
  size?: Size
}

export const ModalFooter = ({ alignment = 'right', children, className, size }: ModalFooterProps): ReactElement => (
  <Styled.ModalFooterWrapper alignment={alignment} className={className} size={size}>
    {children}
  </Styled.ModalFooterWrapper>
)
